/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseCancelledEvent = {
  type: "response.cancelled";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseCancelledEvent$inboundSchema: z.ZodType<
  ResponseCancelledEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.cancelled"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseCancelledEvent$Outbound = {
  type: "response.cancelled";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseCancelledEvent$outboundSchema: z.ZodType<
  ResponseCancelledEvent$Outbound,
  z.ZodTypeDef,
  ResponseCancelledEvent
> = z.object({
  type: z.literal("response.cancelled"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseCancelledEventToJSON(
  responseCancelledEvent: ResponseCancelledEvent,
): string {
  return JSON.stringify(
    ResponseCancelledEvent$outboundSchema.parse(responseCancelledEvent),
  );
}
export function responseCancelledEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseCancelledEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseCancelledEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseCancelledEvent' from JSON`,
  );
}
